import { GitLabState } from "@/store/gitlab/state";
import { gitlabUrl } from "@/env";
import { getStoreAccessors } from "typesafe-vuex";
import { State as RootState } from "../state";
import axios from "axios";

export const getters = {
  getGitLabInfo(state: GitLabState) {
    return state.gitlab;
  },

  getAccessToken(state: GitLabState) {
    axios.defaults.headers["PRIVATE-TOKEN"] = state.gitlab.accessToken;
    return state.gitlab.accessToken;
  },

  getProjectBaseUrl(state: GitLabState) {
    return `${gitlabUrl}/api/v4/projects/${state.gitlab.projectId}/`;
  }
};

const { read } = getStoreAccessors<GitLabState, RootState>("");

export const readGitLabInfo = read(getters.getGitLabInfo);
export const readAccessToken = read(getters.getAccessToken);
export const readBaseUrl = read(getters.getProjectBaseUrl);
